import { Parking } from '@/service'

export const getParkingLabel = (parking: Parking, t: any) => {
  const translationKey = parking?.translationKeys?.parkingLotName
  return translationKey ? t(translationKey as any) : parking?.shortDisplayName
}
